var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 16.2a6.2 6.2 0 1 0 0-12.4 6.2 6.2 0 0 0 0 12.4Zm0 .8a7 7 0 1 0 0-14 7 7 0 0 0 0 14ZM9.25 7a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0ZM10 8.86a.75.75 0 0 0-.75.75v3.5a.75.75 0 0 0 1.5 0v-3.5a.75.75 0 0 0-.75-.75Z",
    fill: "currentColor"
  })));
};
export default SvgInfo;